module.exports = __webpack_public_path__ + "img/DSC_2675.5b0ec293.png";